import { ResourceDescriptor } from "./common";

const role: ResourceDescriptor = {
    url: "role", // there is no frontend endpoint for this resource, but needed to edit allowed_networks in dialog
    orders: {
        list: [],
        update: ["name"],
    },
    crudActions: ["update"],
    identifiers: ["name"],
    initialDataPostProcess: (data) => {
        data.allowed_networks ??= [];
        return data;
    },
};

export default role;
